import { isRequired, minimun, maximum } from 'validations/defaultMessages';
import * as Yup from 'yup';

import { EChargeType } from '../../classes/Product';

const Payment = {
  paymentsSchema: Yup.object().shape({
    charge_type: Yup.string().required(isRequired('tipo de pagamento')),
    price: Yup.number().required(isRequired('preço do produto')).min(5, minimun('preço do produto', 5)),
    recurring_frequency_type: Yup.string()
      .nullable()
      .when('charge_type', {
        is: EChargeType.SUBSCRIPTION,
        then: Yup.string().required(isRequired('tipo de frequência de cobrança')),
      }),
    recurring_frequency: Yup.number()
      .nullable()
      .when('charge_type', {
        is: EChargeType.SUBSCRIPTION,
        then: Yup.number().required(isRequired('frequência')).min(1, minimun('frequência', 1)),
      }),
    limit_charges: Yup.number().when('undetermined_charges', {
      is: true,
      then: Yup.number().required(isRequired('limite de cobranças')).min(2, minimun('limite de cobranças', 2)),
    }),
    trial_days: Yup.number()
      .nullable()
      .when('has_trial', {
        is: true,
        then: Yup.number()
          .required(isRequired('quantidade de dias'))
          .min(1, minimun('quantidade de dias', 1))
          .max(90, maximum('quantidade de dias', 90)),
      }),
  }),
  checkoutSchema: Yup.object().shape({
    url_thankyou_boleto: Yup.string()
      .nullable()
      .when('allows_boleto', {
        is: true,
        then: Yup.string().url('Digite uma url válida'),
      }),
    url_thankyou_card: Yup.string()
      .nullable()
      .when('allows_card', {
        is: true,
        then: Yup.string().url('Digite uma url válida'),
      }),
  }),
  recoverySchema: Yup.object().shape({
    recovery_email: Yup.string()
      .nullable()
      .when('sales_recovery', {
        is: true,
        then: Yup.string().required(isRequired('remetente de e-mail')).email('Digite um e-mail válido'),
      }),
  }),
};

export default Payment;
